import React from "react";

import {
  BagsIcon,
  BooksIcon,
  CarIcon,
  ComputerPartsIcon,
  CostumeJewelryIcon,
  EBooksIcon,
  GamesIcon,
  GlassesIcon,
  HeadphonesIcon,
  HealthIcon,
  HomeGoodsIcon,
  MixedIcon,
  MobileIcon,
  MusicsIcon,
  OtherIcon,
  PowerBankIcon,
  ShirtIcon,
  ShoesIcon,
  SportsIcon,
  ToysIcon,
  WatchesIcon,
  BabiesIcon,
  ConstructionIcon,
  JewelryIcon,
  FoodIcon,
  ComputersIcon,
  LightingIcon,
  MusicInstrumentsIcon,
  MedicationsIcon,
  FurnitureIcon,
  OfficeAndStationeryIcon,
  SafetyIcon,
  BooksGeIcon,
  Ebook2Icon,
  ForBabyIcon,
  Jewelry2Icon,
  MusicMovieIcon,
  PhonePartsIcon,
  TabletIcon,
  VariousGoodsIcon,
  GadgetsIcon,
} from "@/components/assets/icons/parcel-category";

import {
  Theme,
  ParcelCategoryUZ,
  ParcelCategoryGe,
  ParcelCategoryUK,
} from "@/enums";

export const themeColorMap = {
  [Theme.UZ]: {
    lightGreen: [
      ParcelCategoryUZ.CLOTHING,
      ParcelCategoryUZ.TOYS_AND_CHILDREN_GOODS,
      ParcelCategoryUZ.WATCHES,
      ParcelCategoryUZ.COSTUME_JEWELRY,
      ParcelCategoryUZ.FOR_BABIES,
      ParcelCategoryUZ.FURNITURE,
      ParcelCategoryUZ.FOOD_PRODUCTS,
    ],
    purple: [
      ParcelCategoryUZ.SHOES,
      ParcelCategoryUZ.SPORTS_AND_LEISURE_GOODS,
      ParcelCategoryUZ.BAGS,
      ParcelCategoryUZ.HEALTH_AND_BEAUTY,
      ParcelCategoryUZ.OFFICE_AND_STATIONERY,
      ParcelCategoryUZ.MUSIC_INSTRUMENTS,
      ParcelCategoryUZ.JEWELRY_AND_ACCESSORIES,
    ],
    orange: [
      ParcelCategoryUZ.AUTOMOTIVE_INDUSTRY,
      ParcelCategoryUZ.BOOKS_MOVIES_MUSIC_AND_GAMES,
      ParcelCategoryUZ.HEADPHONES,
      ParcelCategoryUZ.COSMETICS_AND_HEALTH_PRODUCTS,
      ParcelCategoryUZ.LIGHTING,
      ParcelCategoryUZ.TECH_AND_COMPUTERS,
    ],
    blue: [
      ParcelCategoryUZ.MOBILE_PHONES,
      ParcelCategoryUZ.MIXED_PRODUCTS,
      ParcelCategoryUZ.COMPUTER_PARTS,
      ParcelCategoryUZ.AUTO_MOTO_AND_INDUSTRIAL_GOODS,
      ParcelCategoryUZ.SAFETY_AND_PROTECTION,
      ParcelCategoryUZ.MEDICATIONS_AND_MEDICAL_INSTRUMENTS,
      ParcelCategoryUZ.CONSTRUCTION_AND_RENOVATION,
    ],
    gray: [
      ParcelCategoryUZ.MOVIES_MUSIC,
      ParcelCategoryUZ.HOME_AND_GARDEN,
      ParcelCategoryUZ.BOOKS,
      ParcelCategoryUZ.OTHER,
    ],
    pink: [
      ParcelCategoryUZ.GAMES,
      ParcelCategoryUZ.ACCESSORIES,
      ParcelCategoryUZ.E_BOOKS,
      ParcelCategoryUZ.DO_NOT_USE_MOBILE_PHONE,
      ParcelCategoryUZ.HOME_GOODS,
    ],
    green: [
      ParcelCategoryUZ.POWERBANKS_AND_CHARGING_STATIONS,
      ParcelCategoryUZ.TECH_AND_ELECTRONICS,
      ParcelCategoryUZ.GLASSES,
      ParcelCategoryUZ.TECH_AND_COMPUTERS,
    ],
  },
  [Theme.GEORGIA]: {
    lightGreen: [
      ParcelCategoryGe.MOVIES_MUSIC,
      ParcelCategoryGe.BAGS,
      ParcelCategoryGe.CLOTH,
      ParcelCategoryGe.PHONE_PARTS,
    ],
    purple: [
      ParcelCategoryGe.WATCH,
      ParcelCategoryGe.IPADS_TABLETS,
      ParcelCategoryGe.SHOES,
      ParcelCategoryGe.COSMETICS,
    ],
    orange: [
      ParcelCategoryGe.AUTO_MOTO_GOODS,
      ParcelCategoryGe.GLASSES,
      ParcelCategoryGe.CELL_PHONES,
      ParcelCategoryGe.GOODS_FOR_KIDS,
      ParcelCategoryGe.GAMES,
      ParcelCategoryGe.VARIOUS_GOODS,
    ],
    blue: [
      ParcelCategoryGe.COMPUTER_PARTS,
      ParcelCategoryGe.HEADPHONES,
      ParcelCategoryGe.COMPUTER_TECHINCS,
      ParcelCategoryGe.GADGETS,
    ],
    // gray: [,],
    pink: [
      ParcelCategoryGe.ELECTRONIC_BOOKS,
      ParcelCategoryGe.IMITATION_JEWELRY,
      ParcelCategoryGe.VITAMINS_AND_DIETARY_SUPPLEMENTS,
    ],
    green: [ParcelCategoryGe.BOOKS, ParcelCategoryGe.HOUSEHOLD_GARDENING],
  },
  [Theme.UK]: {
    lightGreen: [
      ParcelCategoryUK.MOVIES_MUSIC,
      ParcelCategoryUK.BAGS,
      ParcelCategoryUK.CLOTH,
      ParcelCategoryUK.PHONE_PARTS,
    ],
    purple: [
      ParcelCategoryUK.WATCH,
      ParcelCategoryUK.IPADS_TABLETS,
      ParcelCategoryUK.SHOES,
      ParcelCategoryUK.COSMETICS,
    ],
    orange: [
      ParcelCategoryUK.REPAIR_PARTS,
      ParcelCategoryUK.GLASSES,
      ParcelCategoryUK.CELL_PHONES,
      ParcelCategoryUK.GOODS_FOR_KIDS,
      ParcelCategoryUK.GAMES,
      ParcelCategoryUK.VARIOUS_GOODS,
    ],
    blue: [
      ParcelCategoryUK.COMPUTER_PARTS,
      ParcelCategoryUK.HEADPHONES,
      ParcelCategoryUK.COMPUTER_TECHNICS,
      ParcelCategoryUK.GADGETS,
    ],
    // gray: [],
    pink: [
      ParcelCategoryUK.ELECTRONIC_BOOKS,
      ParcelCategoryUK.IMITATION_JEWELRY,
      ParcelCategoryUK.VITAMINS_AND_DIETARY_SUPPLEMENTS,
    ],
    green: [
      ParcelCategoryUK.BOOKS,
      ParcelCategoryUK.HOUSEHOLD_GARDENING,
      ParcelCategoryUK.POWER_BANKS_AND_CHARGERS,
    ],
  },
};

export const themeIconMap = {
  [Theme.UZ]: {
    [ParcelCategoryUZ.TOYS_AND_CHILDREN_GOODS]: ToysIcon,
    [ParcelCategoryUZ.SPORTS_AND_LEISURE_GOODS]: SportsIcon,
    [ParcelCategoryUZ.BOOKS_MOVIES_MUSIC_AND_GAMES]: BooksIcon,
    [ParcelCategoryUZ.HEALTH_AND_BEAUTY]: HealthIcon,
    [ParcelCategoryUZ.MIXED_PRODUCTS]: MixedIcon,
    [ParcelCategoryUZ.HOME_AND_GARDEN]: HomeGoodsIcon,
    [ParcelCategoryUZ.AUTOMOTIVE_INDUSTRY]: CarIcon,
    [ParcelCategoryUZ.TECH_AND_COMPUTERS]: ComputerPartsIcon,
    [ParcelCategoryUZ.OTHER]: OtherIcon,
    [ParcelCategoryUZ.CLOTHING]: ShirtIcon,
    [ParcelCategoryUZ.SHOES]: ShoesIcon,
    [ParcelCategoryUZ.ACCESSORIES]: OtherIcon,
    [ParcelCategoryUZ.DO_NOT_USE_MOBILE_PHONE]: MobileIcon,
    [ParcelCategoryUZ.GLASSES]: GlassesIcon,
    [ParcelCategoryUZ.E_BOOKS]: EBooksIcon,
    [ParcelCategoryUZ.WATCHES]: WatchesIcon,
    [ParcelCategoryUZ.BAGS]: BagsIcon,
    [ParcelCategoryUZ.HEADPHONES]: HeadphonesIcon,
    [ParcelCategoryUZ.COSTUME_JEWELRY]: CostumeJewelryIcon,
    [ParcelCategoryUZ.COMPUTER_PARTS]: ComputerPartsIcon,
    [ParcelCategoryUZ.MOVIES_MUSIC]: MusicsIcon,
    [ParcelCategoryUZ.GAMES]: GamesIcon,
    [ParcelCategoryUZ.BOOKS]: BooksIcon,
    [ParcelCategoryUZ.POWERBANKS_AND_CHARGING_STATIONS]: PowerBankIcon,
    [ParcelCategoryUZ.TECH_AND_ELECTRONICS]: ComputerPartsIcon,
    [ParcelCategoryUZ.AUTO_MOTO_AND_INDUSTRIAL_GOODS]: CarIcon,
    [ParcelCategoryUZ.COSMETICS_AND_HEALTH_PRODUCTS]: HealthIcon,
    [ParcelCategoryUZ.MOBILE_PHONES]: MobileIcon,
    [ParcelCategoryUZ.HOME_GOODS]: HomeGoodsIcon,
    [ParcelCategoryUZ.COMPUTERS_AND_OFFICE_SUPPLIES]: ComputersIcon,
    [ParcelCategoryUZ.SAFETY_AND_PROTECTION]: SafetyIcon,
    [ParcelCategoryUZ.FOR_BABIES]: BabiesIcon,
    [ParcelCategoryUZ.OFFICE_AND_STATIONERY]: OfficeAndStationeryIcon,
    [ParcelCategoryUZ.FURNITURE]: FurnitureIcon,
    [ParcelCategoryUZ.MEDICATIONS_AND_MEDICAL_INSTRUMENTS]: MedicationsIcon,
    [ParcelCategoryUZ.MUSIC_INSTRUMENTS]: MusicInstrumentsIcon,
    [ParcelCategoryUZ.LIGHTING]: LightingIcon,
    [ParcelCategoryUZ.FOOD_PRODUCTS]: FoodIcon,
    [ParcelCategoryUZ.CONSTRUCTION_AND_RENOVATION]: ConstructionIcon,
    [ParcelCategoryUZ.JEWELRY_AND_ACCESSORIES]: JewelryIcon,
  },
  [Theme.GEORGIA]: {
    [ParcelCategoryUK.VARIOUS_GOODS]: VariousGoodsIcon,
    [ParcelCategoryUK.GADGETS]: GadgetsIcon,
    [ParcelCategoryGe.AUTO_MOTO_GOODS]: CarIcon,
    [ParcelCategoryGe.COSMETICS]: HealthIcon,
    [ParcelCategoryGe.HOUSEHOLD_GARDENING]: HomeGoodsIcon,
    [ParcelCategoryGe.GOODS_FOR_KIDS]: ForBabyIcon,
    [ParcelCategoryGe.CLOTH]: ShirtIcon,
    [ParcelCategoryGe.SHOES]: ShoesIcon,
    [ParcelCategoryGe.BOOKS]: BooksGeIcon,
    [ParcelCategoryGe.GAMES]: GamesIcon,
    [ParcelCategoryGe.MOVIES_MUSIC]: MusicMovieIcon,
    [ParcelCategoryGe.COMPUTER_PARTS]: ComputerPartsIcon,
    [ParcelCategoryGe.IMITATION_JEWELRY]: Jewelry2Icon,
    [ParcelCategoryGe.GLASSES]: GlassesIcon,
    [ParcelCategoryGe.BAGS]: BagsIcon,
    [ParcelCategoryGe.HEADPHONES]: HeadphonesIcon,
    [ParcelCategoryGe.WATCH]: WatchesIcon,
    [ParcelCategoryGe.CELL_PHONES]: MobileIcon,
    [ParcelCategoryGe.ELECTRONIC_BOOKS]: Ebook2Icon,
    [ParcelCategoryGe.COMPUTER_TECHINCS]: ComputersIcon,
    [ParcelCategoryGe.PHONE_PARTS]: PhonePartsIcon,
    [ParcelCategoryGe.IPADS_TABLETS]: TabletIcon,
    [ParcelCategoryGe.VITAMINS_AND_DIETARY_SUPPLEMENTS]: HealthIcon,
  },
  [Theme.UK]: {
    [ParcelCategoryUK.VARIOUS_GOODS]: VariousGoodsIcon,
    [ParcelCategoryUK.GADGETS]: GadgetsIcon,
    [ParcelCategoryUK.REPAIR_PARTS]: CarIcon,
    [ParcelCategoryUK.COSMETICS]: HealthIcon,
    [ParcelCategoryUK.HOUSEHOLD_GARDENING]: HomeGoodsIcon,
    [ParcelCategoryUK.GOODS_FOR_KIDS]: ForBabyIcon,
    [ParcelCategoryUK.CLOTH]: ShirtIcon,
    [ParcelCategoryUK.SHOES]: ShoesIcon,
    [ParcelCategoryUK.BOOKS]: BooksGeIcon,
    [ParcelCategoryUK.GAMES]: GamesIcon,
    [ParcelCategoryUK.MOVIES_MUSIC]: MusicMovieIcon,
    [ParcelCategoryUK.COMPUTER_PARTS]: ComputerPartsIcon,
    [ParcelCategoryUK.IMITATION_JEWELRY]: Jewelry2Icon,
    [ParcelCategoryUK.GLASSES]: GlassesIcon,
    [ParcelCategoryUK.BAGS]: BagsIcon,
    [ParcelCategoryUK.HEADPHONES]: HeadphonesIcon,
    [ParcelCategoryUK.WATCH]: WatchesIcon,
    [ParcelCategoryUK.CELL_PHONES]: MobileIcon,
    [ParcelCategoryUK.ELECTRONIC_BOOKS]: Ebook2Icon,
    [ParcelCategoryUK.COMPUTER_TECHNICS]: ComputersIcon,
    [ParcelCategoryUK.PHONE_PARTS]: PhonePartsIcon,
    [ParcelCategoryUK.IPADS_TABLETS]: TabletIcon,
    [ParcelCategoryUK.VITAMINS_AND_DIETARY_SUPPLEMENTS]: HealthIcon,
    [ParcelCategoryUK.POWER_BANKS_AND_CHARGERS]: PowerBankIcon,
    [ParcelCategoryUK.STARLINK]: OtherIcon,
  },
};

// Maps every shipmentTypeId to an icon.
// All items sharing the same shipmentTypeParentId use the same icon.
export const shipmentTypeIconMapUK: Record<number, React.ComponentType> = {
  // parentId 210 — Computer parts
  15: ComputerPartsIcon, // Laptop parts
  146: ComputerPartsIcon, // Transistors
  153: ComputerPartsIcon, // Mouse pad

  // parentId 250 — Phone parts
  123: PhonePartsIcon, // Mobile phone parts

  // parentId 260 — iPads, tablets
  45: TabletIcon, // Tablet

  // parentId 220 — Imitation jewelry
  12: Jewelry2Icon, // Imitation jewelry

  // parentId 230 — Electronic books
  3: Ebook2Icon, // Kindle
  4: Ebook2Icon, // E-book

  // parentId 2 — Vitamins and dietary supplements
  43: HealthIcon, // Vitamins

  // parentId 280 — Starlink
  105: OtherIcon, // Starlink

  // parentId 25 — Household and gardening goods
  9: HomeGoodsIcon, // Embroidery
  14: HomeGoodsIcon, // Vase
  17: HomeGoodsIcon, // Pet accessories
  22: HomeGoodsIcon, // Fishing reels
  24: HomeGoodsIcon, // Coffee
  25: HomeGoodsIcon, // Fishing hooks
  41: HomeGoodsIcon, // Kitchen tools of wood
  42: HomeGoodsIcon, // Kitchen tools of plastic
  44: HomeGoodsIcon, // Sports equipment
  49: HomeGoodsIcon, // Statuette
  57: HomeGoodsIcon, // Christmas tree artificial
  61: HomeGoodsIcon, // Lighter
  68: HomeGoodsIcon, // Cable
  79: HomeGoodsIcon, // Kitchen knives
  88: HomeGoodsIcon, // Scissors
  89: HomeGoodsIcon, // Garden tools
  96: HomeGoodsIcon, // Cookies
  104: HomeGoodsIcon, // Candle
  106: HomeGoodsIcon, // Sweets
  108: HomeGoodsIcon, // Sauce
  115: HomeGoodsIcon, // Fishing rods
  117: HomeGoodsIcon, // Chips
  125: HomeGoodsIcon, // Stationery or school supplies
  126: HomeGoodsIcon, // Fishing accessories and other fishing tackle
  127: HomeGoodsIcon, // Adapter
  136: HomeGoodsIcon, // Case
  137: HomeGoodsIcon, // Vinyl records
  140: HomeGoodsIcon, // Flashlight
  147: HomeGoodsIcon, // Audio cassettes
  148: HomeGoodsIcon, // Fabric
  149: HomeGoodsIcon, // Fittings
  151: HomeGoodsIcon, // Pillow
  154: HomeGoodsIcon, // Tea
  158: HomeGoodsIcon, // Fun (cooler)
  160: HomeGoodsIcon, // Washing preparations
  162: HomeGoodsIcon, // Materials for medicine and first-aid kits
  163: HomeGoodsIcon, // Multitool

  // parentId 12 — Cloths
  5: ShirtIcon, // Women's jacket
  27: ShirtIcon, // Men's jacket
  37: ShirtIcon, // Women's underwear
  38: ShirtIcon, // Men's underwear
  39: ShirtIcon, // Women's Blouses
  50: ShirtIcon, // Men's pants
  51: ShirtIcon, // Men's jeans
  52: ShirtIcon, // Women's jeans
  58: ShirtIcon, // Women's shorts
  69: ShirtIcon, // Cap
  72: ShirtIcon, // Women's tights
  73: ShirtIcon, // Socks
  75: ShirtIcon, // Men's suit
  76: ShirtIcon, // Women's suit
  80: ShirtIcon, // T-shirt
  85: ShirtIcon, // Men's shirt
  86: ShirtIcon, // Men's shorts
  97: ShirtIcon, // Pajamas
  98: ShirtIcon, // Women's dress
  99: ShirtIcon, // Women's hat
  100: ShirtIcon, // Belt
  103: ShirtIcon, // Women's shirt
  116: ShirtIcon, // T-shirt
  118: ShirtIcon, // Hat
  119: ShirtIcon, // Women's pants
  122: ShirtIcon, // Women's skirt
  124: ShirtIcon, // Gloves
  134: ShirtIcon, // Sweater
  138: ShirtIcon, // Kids' clothing
  165: ShirtIcon, // Scarf

  // parentId 11 — Shoes
  34: ShoesIcon, // Boots
  35: ShoesIcon, // Sandals
  36: ShoesIcon, // Heeled shoes
  77: ShoesIcon, // Sports shoes
  78: ShoesIcon, // Sneakers
  90: ShoesIcon, // Kids shoes
  91: ShoesIcon, // Snowboard boots

  // parentId 20 — Cell-phones used
  110: MobileIcon, // Cell phone

  // parentId 21 — Gadgets used
  2: GadgetsIcon, // Headphones
  6: GadgetsIcon, // Massager
  19: GadgetsIcon, // Camera
  20: GadgetsIcon, // Laptop/PC
  23: GadgetsIcon, // Keyboard
  26: GadgetsIcon, // Monitor
  40: GadgetsIcon, // Video card
  53: GadgetsIcon, // Game console
  54: GadgetsIcon, // Virtual reality glasses
  55: GadgetsIcon, // Drill
  56: GadgetsIcon, // Screwdriver
  62: GadgetsIcon, // Guitar spare part
  67: GadgetsIcon, // Power tools
  84: GadgetsIcon, // Computer mouse
  102: GadgetsIcon, // Straps, ribbons and bracelets for watches
  107: GadgetsIcon, // Watch
  112: GadgetsIcon, // TV
  114: GadgetsIcon, // Humidifier
  128: GadgetsIcon, // RAM
  129: GadgetsIcon, // CPU
  130: GadgetsIcon, // Flash memory card
  132: GadgetsIcon, // Hard disk
  133: GadgetsIcon, // Server
  135: GadgetsIcon, // Lens
  139: GadgetsIcon, // Loudspeaker
  141: GadgetsIcon, // DVD disc
  142: GadgetsIcon, // Microphone
  143: GadgetsIcon, // TV box
  144: GadgetsIcon, // Parts and accessories of printers
  145: GadgetsIcon, // Printer
  150: GadgetsIcon, // Projector
  152: GadgetsIcon, // Radio
  155: GadgetsIcon, // Video camera spare parts
  159: GadgetsIcon, // Vacuum
  161: GadgetsIcon, // Game controller
  164: GadgetsIcon, // Turntable (record-player)
  166: GadgetsIcon, // Router

  // parentId 8 — Cosmetics
  8: HealthIcon, // Hair accessories
  10: HealthIcon, // First-aid kit
  11: HealthIcon, // Lip balm
  13: HealthIcon, // Adhesive plasters
  46: HealthIcon, // Deodorant
  59: HealthIcon, // Face make up
  60: HealthIcon, // Body lotions
  63: HealthIcon, // Tooth paste
  64: HealthIcon, // Tooth brush
  81: HealthIcon, // Manicure scissors
  82: HealthIcon, // Tourniquet
  83: HealthIcon, // Medical instrument
  93: HealthIcon, // Dental glasses
  94: HealthIcon, // Dental instruments
  95: HealthIcon, // Perfume
  101: HealthIcon, // Condoms
  109: HealthIcon, // Hair care products
  120: HealthIcon, // Hair brushes
  131: HealthIcon, // Make up brushes

  // parentId 4 — Goods for kids
  48: ToysIcon, // Games
  65: ToysIcon, // Toys
  66: ToysIcon, // Toys (dolls)
  87: ToysIcon, // Stuffed toys

  // parentId 3 — Repair parts
  18: CarIcon, // Other car parts
  21: CarIcon, // Headlight
  28: CarIcon, // Car charger
  30: CarIcon, // Bumper
  31: CarIcon, // Car mirror
  32: CarIcon, // Car Tires
  33: CarIcon, // Shock-absorber
  70: CarIcon, // Car key
  113: CarIcon, // Brake pads
  156: CarIcon, // All ATV parts (motorcycle, quad bike)

  // parentId 180 — Power banks and charge stations
  7: PowerBankIcon, // Charger for a cell phone/watches
  29: PowerBankIcon, // Battery Charger
  111: PowerBankIcon, // Power banks and charge stations
  157: PowerBankIcon, // Inverter

  // parentId 7 — Books
  71: BooksGeIcon, // Books

  // parentId 13 — Glasses
  92: GlassesIcon, // Sunglasses

  // parentId 19 — Bag/purse
  1: BagsIcon, // Bag
  74: BagsIcon, // Backpack, travel bag
};

// Maps shipmentTypeParentId to an icon for Ukraine.
export const shipmentTypeParentIconMapUK: Record<number, React.ComponentType> =
  {
    [ParcelCategoryUK.VARIOUS_GOODS]: VariousGoodsIcon, // 3
    [ParcelCategoryUK.GADGETS]: GadgetsIcon, // 6
    [ParcelCategoryUK.REPAIR_PARTS]: CarIcon, // 11
    [ParcelCategoryUK.COSMETICS]: HealthIcon, // 16
    [ParcelCategoryUK.HOUSEHOLD_GARDENING]: HomeGoodsIcon, // 17
    [ParcelCategoryUK.GOODS_FOR_KIDS]: ForBabyIcon, // 21
    [ParcelCategoryUK.CLOTH]: ShirtIcon, // 45
    [ParcelCategoryUK.SHOES]: ShoesIcon, // 46
    [ParcelCategoryUK.CELL_PHONES]: MobileIcon, // 168
    [ParcelCategoryUK.POWER_BANKS_AND_CHARGERS]: PowerBankIcon, // 180
    [ParcelCategoryUK.BOOKS]: BooksGeIcon, // 190
    [ParcelCategoryUK.GAMES]: GamesIcon, // 200
    [ParcelCategoryUK.MOVIES_MUSIC]: MusicMovieIcon, // 210
    [ParcelCategoryUK.COMPUTER_PARTS]: ComputerPartsIcon, // 220
    [ParcelCategoryUK.IMITATION_JEWELRY]: Jewelry2Icon, // 230
    [ParcelCategoryUK.GLASSES]: GlassesIcon, // 242
    [ParcelCategoryUK.BAGS]: BagsIcon, // 244
    [ParcelCategoryUK.ELECTRONIC_BOOKS]: Ebook2Icon, // 250
    [ParcelCategoryUK.COMPUTER_TECHNICS]: ComputersIcon, // 260
    [ParcelCategoryUK.PHONE_PARTS]: PhonePartsIcon, // 270
    [ParcelCategoryUK.IPADS_TABLETS]: TabletIcon, // 280
    [ParcelCategoryUK.VITAMINS_AND_DIETARY_SUPPLEMENTS]: HealthIcon, // 290
    [ParcelCategoryUK.STARLINK]: OtherIcon, // 310
  };
